import { render } from "./Thanks.vue?vue&type=template&id=b0c037ca&scoped=true&lang=html"
import script from "./Thanks.vue?vue&type=script&lang=js"
export * from "./Thanks.vue?vue&type=script&lang=js"

import "./Thanks.vue?vue&type=style&index=0&id=b0c037ca&lang=css&scoped=true"

import exportComponent from "C:\\Users\\dev2\\Documents\\dev\\sitio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0c037ca"]])

export default __exports__